import { matchPath } from 'react-router-dom';
// Без alias: модуль проверяет tests/nav-sections.test.ts бандлом esbuild под Node (notes.md), paths.ts — без импортов.
import { paths } from '../../shared/config/paths';

/**
 * Разделы навигации (решение владельца 2026-10-23: навигация, понятная с первого входа в кабинет).
 * Вкладка телефона и пункт боковой панели подсвечивают раздел, а не только свой адрес: модуль — часть «Слов и модулей»,
 * тренировка и «Задание дня» открываются с главной, настройки и тарифы — в «Ещё».
 */
export type NavSection = 'home' | 'words' | 'grammar' | 'game' | 'more';

const SECTIONS: readonly (readonly [NavSection, readonly string[]])[] = [
  ['home', [paths.dashboard, paths.training, paths.dailyTask]],
  ['words', [paths.words, paths.unit, paths.libraryItem, paths.topicCards]],
  ['grammar', [paths.grammar, paths.grammarLesson]],
  ['game', [`${paths.stories}/*`]],
  ['more', [`${paths.useful}/*`, paths.community, paths.notifications, paths.profile, paths.plans, paths.admin]],
];

/** Раздел страницы; тренировка модуля и прочие экраны вне разделов — `null` (ничего не подсвечено). */
export function navSectionOf(pathname: string): NavSection | null {
  for (const [section, patterns] of SECTIONS) {
    if (patterns.some((path) => matchPath({ path, end: true }, pathname))) return section;
  }
  return null;
}
